module.exports = __webpack_public_path__ + "static/media/arcanum-totem.6a3ebc84.png";